import React, {Component} from 'react';
import code from "assets/img/code1.PNG";
import codeThree from "assets/img/code3.PNG";
import codefour from "assets/img/code4.PNG";
import codefive from "assets/img/code5.PNG";

class DocumentationTwo extends Component {
    render() {
        return (
           <div>
                           <div>
                               <div className="p-20">
                               <br />
                                   <p>Download and import API Calls collection.</p>
                                    <br/>
                                   <img src={codefive} alt={codefive} className="mSpaceLogo" width={'98%'}/>
                                   <div className="clearfix"></div>

                                   <br/>
                                   <blockquote>

                                       <small>This will download API collection JSON file, import in Postman application.</small>
                                       <small>Click on import button.</small>
                                   </blockquote>
                               </div>
                           </div>
                            <div className="">
                                <div className="clearfix"></div>
                               <img src={codeThree} alt={codeThree} className="mSpaceLogo" width={'90%'}/>
                                <div className="clearfix"></div>
                               <br/>
                               <blockquote>
                                   <small>Select Import file and choose downloaded <b>(cloudintegration_collections.json)</b> API Collection JSON file.</small>
                               </blockquote>
                                <div className="clearfix"></div>
                               <img src={codefour} alt={codefour} className="mSpaceLogo" width={'90%'}/>
                                <div className="clearfix"></div>
                               <br/>
                               <blockquote>
                                   <small>Now select desired API tab , fill request data and send request.</small>
                               </blockquote>

                               </div>
                       </div>
        );
    }
}

export default DocumentationTwo;